import { createHOC } from 'vue-hoc';
import jwt_decode from 'jwt-decode';

import InviteTokenHandler from './InviteTokenHandler';
import auth from '../../../../lib/common/providers/auth';
import userManagement from '../../../../lib/common/providers/userManagement';
import withUser from '../../../../lib/common/hoc/withUser';

const options = {
  name: 'InviteTokenHandlerContainer',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      state: {
        loading: false,
        error: null,
      },
    };
  },
};

const renderWith = {
  props: {
    error() {
      return this.state.error;
    },
    loading() {
      return this.state.loading;
    },
  },
  listeners: {
    async acceptInvite() {
      const { query } = this.$route;
      const { token } = query;      
      this.state.error = null;
      this.state.loading = true;
      try {
        if (!token) {
          throw new Error('Missing invite token');
        }
        const decodedToken = jwt_decode(token);
        if (!this.user || this.user.email !== decodedToken.email) {
          this.$router.push({
            name: 'login',
            query: { redirectUrl: window.location.href },
          });
        }
        await userManagement.post(
          '/invitations/finish',
          {
            email: this.user.email,
          },
          {
            headers: {
              Authorization: `Bearer ${query.token}`,
            },
          }
        );
        await userManagement.post('/auth/changeOrg', {
          orgId: decodedToken.orgId,
        });
        await auth.renewSession();
        this.$router.push({
          name: 'profile',
        });
      } catch (error) {
        console.error(error);
        this.state.error = {
          ...error,
          message: error.message || error.description,
        };
      } finally {
        this.state.loading = false;
      }
    },
  },
};

const InviteTokenHandlerContainer = createHOC(
  InviteTokenHandler,
  options,
  renderWith
);
export default withUser()(InviteTokenHandlerContainer);
